import { APARTMENTS_TYPES } from "./apartmentsTypes";
import { convertToObjById, toArray } from "helpers/convertToObject";

const {
  LOAD_APARTMENTS,
  SET_APARTMENTS,
  NEW_APARTMENT,
  SET_UPSERT_APARTMENT,
  EDIT_APARTMENT,
  ASSIGN_METER,
  ASSIGN_CUSTOMER,
  ASSIGN_CONTRACT,
  SELECTED_METER,
  SEARCH_CUSTOMERS,
  CLEAR_APARTMENTS,
  HANDLE_APARTMENTS_INPUTS,
} = APARTMENTS_TYPES;

const initialState = {
  apartments: [],
  apartmentList: [],
  apartmentsMap: {},
  statuses: [],
  businesses: [],
  //edit
  isAddMode: false,
  isMeterModal: false,
  editApartment: null,
  station: null,
  config: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: []
  }
};

const toList = apartment => ({
  ...apartment,
  facility: apartment.facility?.name,
  idFacility: apartment.facility?.id,
  customer: apartment.customer?.name,
  contract: apartment.customer?.contract,
  idCustomer: apartment.customer?.id,
  meter: apartment.meter?.number,
  idmeter: apartment.meter?.id
});

export const apartmentsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HANDLE_APARTMENTS_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value
      };
    case LOAD_APARTMENTS:
      return {
        ...state
      };

    case CLEAR_APARTMENTS:
      return {
        ...state,
        ...initialState
      };

    case SET_APARTMENTS: {
      const apartmentsMap = convertToObjById(payload.apartments);

      return {
        ...state,
        idStation: payload.idStation,
        apartments: payload.apartments,
        apartmentList: payload.apartments.map(toList),
        apartmentsMap,
        statuses: payload.statuses.map(status => ({
          id: status,
          value: status,
          label: status
        })),
        businesses: payload.businesses.map(business => ({
          id: business,
          value: business,
          label: business
        })),

        meterList: payload.meters.map(meter => ({
          id: meter.id,
          value: meter.id,
          label: meter.serialNumber
        }))
      };
    }

    case EDIT_APARTMENT:
      return {
        ...state,
        isAddMode: false,
        isMeterModal: false,
        editApartment: payload && state.apartmentsMap[payload]
      };

    case ASSIGN_METER:
      return {
        ...state,
        isAddMode: false,
        isMeterModal: true,
        editApartment: payload && state.apartmentsMap[payload]
      };

    case ASSIGN_CUSTOMER:
      return {
        ...state,
        isAddMode: false,
        isMeterModal: false,
        customerList: null,
        editApartment: payload && state.apartmentsMap[payload]
      };

    case ASSIGN_CONTRACT:
      return {
        ...state,
        isAddMode: false,
        isMeterModal: false,
        customerList: null,
        editApartment: payload && state.apartmentsMap[payload]
      };

    case SELECTED_METER:
      return {
        ...state,
        meterList: state.meterList.filter(_ => _.id != payload)
      };

    case NEW_APARTMENT:
      return {
        ...state,
        isAddMode: true,
        isMeterModal: false
      };

    case SEARCH_CUSTOMERS:
      return {
        ...state,
        customerList: payload.map(_ => ({
          id: _.id,
          value: _.id,
          label: `${_.rfc} - ${_.name} - ${_.address?.fullAddress}`
        }))
      };

    case SET_UPSERT_APARTMENT: {
      const { apartmentsMap } = state;

      const newApartmentsMap = {
        ...apartmentsMap,
        [payload.id]: payload
      };
      const newApartments = toArray(newApartmentsMap);

      return {
        ...state,
        apartments: newApartments,
        apartmentsMap: newApartmentsMap,
        apartmentList: newApartments.map(toList)
      };
    }

    default:
      return state;
  }
};
